export const SEND_CONTACT = 'SEND_CONTACT'
export const SEND_CONTACT_SUCCESS = 'SEND_CONTACT_SUCCESS'
export const SEND_CONTACT_FAILURE = 'SEND_CONTACT_FAILURE'


export const sendContact = (id) => ({
    type: SEND_CONTACT,
    payload: id
})

export const sendContactSuccess = (message) => ({
    type: SEND_CONTACT_SUCCESS,
    payload: message
})

export const sendContactFailed = (message) => ({
    type: SEND_CONTACT_FAILURE,
    payload: message
})
